import { useMemo } from "react";
import {
  BANK_ACCOUNT_NUMBER_REQUIRED,
  BANK_TRANSIT_ROUTING_REQUIRED,
  WRONG_FORMAT_BANK_TRANSIT_ROUTING,
} from "../../../../../../../lib/constants";
import { useRules } from "../../../../../../Account/components/View/Admin/Details/components/PayeeDisbursements/components/DisbursementMethodPart/hooks/useRules";
import { Rule } from "antd/es/form";

export const useFormRules = () => {
  const { bankAccountNumberRule } = useRules();

  const bankAccountNumberRules: Rule[] = useMemo(
    () => [
      ...bankAccountNumberRule,
      {
        required: true,
        message: BANK_ACCOUNT_NUMBER_REQUIRED,
        validateTrigger: "onSubmit",
      },
    ],
    [bankAccountNumberRule]
  );

  const bankTransitRules: Rule[] = useMemo(
    () => [
      {
        pattern: /^\d{9}$/,
        message: WRONG_FORMAT_BANK_TRANSIT_ROUTING,
        validateTrigger: "onSubmit",
      },
      {
        required: true,
        message: BANK_TRANSIT_ROUTING_REQUIRED,
        validateTrigger: "onSubmit",
      },
    ],
    []
  );

  return { bankAccountNumberRules, bankTransitRules };
};
